import {KeyConstant} from "../constant/keyConstant";
import moment from "dayjs";
import React from "react";
import {typeReport} from "./typeReport";
import {DG_Format_Money} from "../../../../format/Money";

const format = "DD/MM/YYYY"
const formatMonth = "MMMM, YYYY"
const formatCompareDMY = "YYYYMMDD"
const formatCompareMY = "YYYYMM"
const formatCompareY = "YYYY"
const mapAboutDays = (startDate , endDate) =>{

    if (moment(startDate).format(formatCompareDMY) === moment(endDate).format(formatCompareDMY)){
        return <>
            <span> {moment(startDate).format(format)} </span>
        </>
    }
    if (moment(startDate).format(formatCompareMY) === moment(endDate).format(formatCompareMY)){
        return <>
            <span> {moment(startDate).format("DD")} </span> -
            <span> {moment(endDate).format(format)} </span>
        </>
    }
    if (moment(startDate).format(formatCompareY) === moment(endDate).format(formatCompareY)){
        return <>
            <span> {moment(startDate).format("DD/MM")} </span> -
            <span> {moment(endDate).format(format)} </span>
        </>
    }
    return <>
        <span> {moment(startDate).format("DD/MM/YYYY")} </span> -
        <span> {moment(endDate).format("DD/MM/YYYY")} </span>
    </>
}
export const mapTitleDate = (type , startDate , endDate)=>{

    switch (type){
        case KeyConstant.TODAY:
        case KeyConstant.YESTERDAY:
            return  moment(startDate).format(format)
        case KeyConstant.THIS_MONTH:
        case KeyConstant.LAST_MONTH:
            return  moment(startDate).format(formatMonth).charAt(0).toUpperCase() +
                moment(startDate).format(formatMonth).slice(1)
        default :
            return mapAboutDays(startDate, endDate)
    }
}

export const getBold = (departmentParent,departmentId, value) => {
    if (departmentParent === 0 || departmentId === KeyConstant.SUMMARY)
        return <span className={"font-bold"}> {value} </span>

    return value
}
export const getBoldTotal = (departmentParent,departmentId, value,searchValue) => {
    if (departmentParent === 0 || departmentId === KeyConstant.SUMMARY)
        return <span className={"font-bold"}> { searchValue ===  typeReport[4]?.value ? DG_Format_Money(value)  : value} </span>

    return value
}
